module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=EH - SADR.3e70ac49.svg";